import React from 'react';

export const handleLoginAccess = () => {
  return <div className="wrapper"><div style={{ display: "flex", justifyContent: "center", flexDirection: "column"}}>
 <p style={{ textAlign: "center" }}>Musisz być zalogowany</p>
  <br/>
  <a href="/login"><button>
  Powrót
</button></a>
</div></div>;
};


